import React from "react";
import outOfStockIcon from "../../../../assets/out-of-stock-icon.svg";

const OutOfStockModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="out-of-stock-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-icon">
          <img src={outOfStockIcon} alt="Out of Stock" />
        </div>
        
        <h2 className="modal-title">Out of Stock</h2>
        <p className="modal-message">
          This product is currently out of stock and cannot be added to the cart.
        </p>
        <button className="modal-ok-btn" onClick={onClose}>
          Ok
        </button>
      </div>
    </div>
  );
};

export default OutOfStockModal;
